var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-lg-3 catalogue-search-card__image-container",class:{
            'catalogue-search-card__image-container--not-found': _vm.couldNotLoadImage,
        }},[_c('img',{staticClass:"card-img-top catalogue-search-card__result-image",class:{
            'catalogue-search-card__result-image--not-found': _vm.couldNotLoadImage,
        },attrs:{"src":_vm.couldNotLoadImage
                ? '/images/broken-image.svg'
                : _vm.src,"alt":_vm.alt},on:{"~error":function($event){return _vm.imageLoadError($event)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }